var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHospitalBedAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 2C19.75 1.58579 19.4142 1.25 19 1.25C18.5858 1.25 18.25 1.58579 18.25 2V4.75L15.4 8.55C15.2296 8.77726 15.2021 9.08132 15.3292 9.33541C15.4562 9.5895 15.7159 9.75 16 9.75H22C22.2841 9.75 22.5438 9.5895 22.6708 9.33541C22.7979 9.08132 22.7704 8.77726 22.6 8.55L19.75 4.75V2ZM17.5 8.25L19 6.25L20.5 8.25H17.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.74955 4C3.16352 4 3.4991 4.33579 3.4991 4.75L3.50417 12.0648C3.66596 12.0225 3.83573 12 4.01076 12H20.0012C21.1051 12 22 12.8954 22 14L21.988 21.2499C21.988 21.6642 21.6525 21.9999 21.2385 21.9999C20.8245 21.9999 20.4889 21.6642 20.4889 21.2499L20.4935 19.25H3.50207L3.4991 21.25C3.4991 21.6642 3.16352 22 2.74955 22C2.33559 22 2 21.6642 2 21.25V4.75C2 4.33579 2.33559 4 2.74955 4ZM9.25 17.75H14.75V16H9.25V17.75ZM7.75 16H3.5069L3.5043 17.75H7.75V16ZM16.25 16V17.75H20.4969L20.5009 16H16.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42815 6.43626C5.68445 6.01908 6.2521 5.87614 6.69603 6.117L9.91125 7.86148C10.3552 8.10234 10.5073 8.63579 10.251 9.05298L9.32283 10.5637C9.06652 10.9809 8.49887 11.1239 8.05494 10.883L4.83972 9.13852C4.39579 8.89766 4.24369 8.36421 4.49999 7.94702L5.42815 6.43626Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalBedAlt2);
export default __webpack_public_path__ + "static/media/hospital-bed-alt-2.4d7d078769e75a54267f4e823ccfd2e0.svg";
export { ForwardRef as ReactComponent };